$(function() {
  const $bannerFixedBottom = $('.banner--bottom-fixed');
  $('.icon.icon-close-o', $bannerFixedBottom)
  .on('click', () => {
    $bannerFixedBottom.remove();
  });
});
